import React from "react";
import "./Stepper.css";
import { CheckCircle, User, Building2, BadgeIndianRupee } from "lucide-react";

const steps = [
  { title: "Company Details", icon: <Building2 size={24} /> },
  { title: "Signatory  Details", icon: <User size={24} /> },
  { title: "KYC Details", icon: <BadgeIndianRupee size={24} /> },
];

const Stepper = ({ currentStep }) => {
  return (
    <div className="stepper-wrapper">
      {steps.map((step, index) => {
        const isCompleted = index < currentStep;
        const isActive = index === currentStep;

        return (
          <div className="step-item" key={index}>
            <div
              className={`step-icon ${
                isCompleted ? "completed" : isActive ? "active" : "upcoming"
              }`}
            >
              {isCompleted ? <CheckCircle size={24} /> : step.icon}
            </div>
            <p
              className={`step-label ${
                isCompleted ? "text-completed" : isActive ? "text-active" : "text-upcoming"
              }`}
            >
              {step.title}
            </p>
            {index !== steps.length - 1 && (
              <div
                className={`step-line ${
                  index < currentStep - 1
                    ? "line-completed"
                    : index === currentStep - 1
                    ? "line-active"
                    : "line-upcoming"
                }`}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Stepper;
